import { Logger } from './logger';

const logger = new Logger();

export default logger;
